import React from "react";
import {
  Box,
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Image from "next/image";

const ChatWithUsSection = () => {
  const theme = useTheme();
  const isLargeMobile = useMediaQuery("(max-width: 1199px)");
  const isMobile = useMediaQuery("(max-width: 599px)");

  return (
    <Box
      sx={{
        maxWidth: "1420px",
        mx: "auto",
        display: "flex",
        flexDirection: { xs: "column", lg: "row" },
        alignItems: "center",
        justifyContent: "space-between",
        gap: { xs: 4, lg: 4 },
        px: { xs: 5, lg: 0 },
        pl: { xs: 5, lg: 5 },
        mt: { xs: 10, md: -10, lg: -20 },
        mb: { xs: 6, lg: -10 },
      }}
    >
      {/* Left Text Content */}
      <Box
        sx={{
          maxWidth: { xs: "100%", lg: "434px" },
          mb: { xs: -20, lg: 0 },
        }}
      >
        <Typography
          sx={{
            fontFamily: "Poppins",
            fontSize: { xs: "28px", lg: "36px" },
            fontWeight: 800,
            color: "#394e2d",
            lineHeight: 1.25,
            mb: { xs: 2, lg: 3 },
          }}
        >
          Real support, when you need it most
        </Typography>
        <Typography
          sx={{
            fontFamily: "RethinkSans, sans-serif",
            fontSize: { xs: "16px", lg: "20px" },
            color: "#212529",
            lineHeight: 1.5,
            mb: { xs: 3, lg: 5 },
          }}
        >
          Our experienced support team is here to help — fast, friendly, and
          ready to solve your shipping challenges anytime.
        </Typography>
        {!isLargeMobile && (
          <Stack
            direction="row"
            spacing={2}
            flexWrap="wrap"
            alignItems="center"
            justifyContent={{ xs: "center", lg: "flex-start" }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#fae627",
                color: "#212529",
                fontFamily: "Poppins",
                fontSize: { xs: "18px", lg: "21px" },
                fontWeight: 500,
                px: 4,
                py: 1.5,
                borderRadius: "8px",
                "&:hover": {
                  backgroundColor: "#f9da00",
                },
              }}
              href="contact-us"
            >
              Contact With Us
            </Button>
          </Stack>
        )}
      </Box>

      {/* Right Image */}
      <Box
        sx={{
          maxWidth: "100%",
          mt: { xs: 8, sm: 0, md: -10, lg: 0 },
        }}
      >
        <Image
          src="/images/Workflow.png"
          alt="Workflow Illustration"
          width={845}
          height={493}
          style={{
            width: "100%",
            height: "auto",
          }}
        />
      </Box>
      {isLargeMobile && (
        <Stack
          direction={isMobile ? "column" : "row"}
          spacing={2}
          flexWrap="wrap"
          alignItems="center"
          width={isMobile ? "100%" : "auto"}
          justifyContent={{ xs: "center", lg: "flex-start" }}
          sx={{ mt: { xs: -8, sm: -14, md: -24 } }}
        >
          <Button
            variant="contained"
            sx={{
              width: isMobile ? "100%" : "auto",
              backgroundColor: "#fae627",
              color: "#212529",
              fontFamily: "Poppins",
              fontSize: { xs: "14px", sm: "18px", lg: "21px" },
              fontWeight: 500,
              px: 2,
              py: 1.5,
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "#f9da00",
              },
            }}
            href="contact-us"
          >
            Contact With Us
          </Button>
        </Stack>
      )}
    </Box>
  );
};

export default ChatWithUsSection;
